import { ObservableFromFetch } from "../ObservableFromFetch"
import GridRow from "./GovPoolModel/GridRow"

export default function PoolUpdateObservable(data: GridRow) {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<string>("GovPool/UpdateGovPool", params, "post")
}
